export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热门视频
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            最新黑料吃瓜视频精选，实时更新热门内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">

          <div className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors duration-300 cursor-pointer">
            <div className="relative aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20video%20thumbnail%20style%2C%20dark%20moody%20background%20with%20warm%20red%20accent%20overlays%2C%20abstract%20paparazzi%20scene%20silhouette%2C%20modern%20digital%20media%20aesthetic%2C%20cinematic%20lighting%20with%20high%20contrast%2C%20clean%20professional%20composition&width=640&height=360&seq=media-card-01&orientation=landscape"
                alt="顶流男星恋情实锤？深夜同回公寓视频全记录"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors duration-300"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-white/90 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                  <i className="ri-play-fill text-xl md:text-2xl ml-0.5"></i>
                </div>
              </div>
              <div className="absolute top-3 right-3 px-2 py-1 rounded bg-black/60 text-white text-xs font-label whitespace-nowrap">
                128万 次播放
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                顶流男星恋情实锤？深夜同回公寓视频全记录
              </h3>
              <p className="mt-2 text-xs text-foreground-400 whitespace-nowrap">3小时前</p>
            </div>
          </div>

          <div className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors duration-300 cursor-pointer">
            <div className="relative aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20TV%20studio%20scene%20with%20dramatic%20red%20lighting%2C%20entertainment%20show%20atmosphere%2C%20dark%20moody%20video%20thumbnail%20style%2C%20professional%20broadcast%20aesthetic%2C%20warm%20spotlight%20effects%2C%20high%20contrast%20editorial%20composition&width=640&height=360&seq=media-card-02&orientation=landscape"
                alt="综艺录制现场突发状况，嘉宾当场翻脸离场"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors duration-300"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-white/90 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                  <i className="ri-play-fill text-xl md:text-2xl ml-0.5"></i>
                </div>
              </div>
              <div className="absolute top-3 right-3 px-2 py-1 rounded bg-black/60 text-white text-xs font-label whitespace-nowrap">
                96万 次播放
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                综艺录制现场突发状况，嘉宾当场翻脸离场
              </h3>
              <p className="mt-2 text-xs text-foreground-400 whitespace-nowrap">6小时前</p>
            </div>
          </div>

          <div className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors duration-300 cursor-pointer">
            <div className="relative aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Digital%20livestream%20scene%20abstract%20representation%2C%20dark%20background%20with%20red%20glitch%20effects%2C%20modern%20social%20media%20aesthetic%2C%20dramatic%20video%20thumbnail%20style%2C%20warm%20crimson%20accents%2C%20cinematic%20editorial%20composition&width=640&height=360&seq=media-card-03&orientation=landscape"
                alt="知名网红直播翻车完整版，评论区炸锅了"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors duration-300"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-white/90 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                  <i className="ri-play-fill text-xl md:text-2xl ml-0.5"></i>
                </div>
              </div>
              <div className="absolute top-3 right-3 px-2 py-1 rounded bg-black/60 text-white text-xs font-label whitespace-nowrap">
                85万 次播放
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                知名网红直播翻车完整版，评论区炸锅了
              </h3>
              <p className="mt-2 text-xs text-foreground-400 whitespace-nowrap">9小时前</p>
            </div>
          </div>

          <div className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors duration-300 cursor-pointer">
            <div className="relative aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Collage%20style%20entertainment%20news%20compilation%20thumbnail%2C%20dark%20dramatic%20background%20with%20gold%20and%20red%20accents%2C%20abstract%20newspaper%20texture%20overlay%2C%20modern%20editorial%20aesthetic%2C%20professional%20media%20design%2C%20cinematic%20lighting&width=640&height=360&seq=media-card-04&orientation=landscape"
                alt="娱乐圈年度大瓜汇总：这些黑料你吃了吗"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors duration-300"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-white/90 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                  <i className="ri-play-fill text-xl md:text-2xl ml-0.5"></i>
                </div>
              </div>
              <div className="absolute top-3 right-3 px-2 py-1 rounded bg-black/60 text-white text-xs font-label whitespace-nowrap">
                210万 次播放
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                娱乐圈年度大瓜汇总：这些黑料你吃了吗
              </h3>
              <p className="mt-2 text-xs text-foreground-400 whitespace-nowrap">1天前</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}